import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/auth.service';
import { AlertService } from '../../Component/alert/alert.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private isLoggingOut = false;

  constructor(
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (
          (err.status === 462 || err.status === 401 || err.status === 403) &&
          !request.url.includes('login/actualizar_token') &&
          !this.isLoggingOut
        ) {
          this.isLoggingOut = true;
          this.mostrarMensajeTokenExpirado();
          setTimeout(() => {
            this.authenticationService.logout();
          }, 5000);
        }
        const error = err.error?.message || err.statusText;
        return throwError(() => error);
      }),
    );
  }

  mostrarMensajeTokenExpirado() {
    this.alertService.showAlert('Su sesión ha expirado, por favor vuelva a iniciar sesión', 'error', 5000);
  }
}
